import React from "react";
import { object, bool, string } from "prop-types";
import get from "lodash/get";
import { Link } from "@quintype/components";
import { HeroImage } from "../../atoms/HeroImage";
import { getStoryHeadline, getStoryLabel, isExternalStory } from "../../utils/story";
import { PublishAndReadTime } from "../../atoms/PublishAndReadTime";
import { Label } from "../../atoms/Label";
import Headline from "../../atoms/Headline";
import SubHeadline from "../../atoms/SubHeadline";

import "./four-col-five-stories-wide-hero.m.css";

export const HeroStory = ({
  story,
  showReadTime,
  showTimestamp,
  showSubheadline,
  isFirstCollection,
  showStorySeparator,
  sectionSlug,
}) => {
  const headline = getStoryHeadline(story);
  let label = getStoryLabel(story);

  const imageUrl =
    get(story, ["alternative", "home", "default", "hero-image", "hero-image-s3-key"]) ||
    get(story, ["hero-image-s3-key"]);

  const externalStoryUrl = isExternalStory(story);
  const href = externalStoryUrl ? externalStoryUrl : `/${story?.slug}`;
  const target = externalStoryUrl ? "_blank" : "_self";
  return (
    <div styleName={isFirstCollection && "first-story-container"}>
      <Link href={href} target={target}>
        <div
          styleName={`story-card ${isFirstCollection ? "first-story" : "last-story"}`}
          style={{ borderBottom: showStorySeparator || "none" }}
        >
          <HeroImage
            story={story}
            widths={[350]}
            headline={headline}
            aspectRatio={isFirstCollection ? [[11.1, 4]] : [[4, 3]]}
            iconSizes={{ width: 48, height: 48 }}
            imageUrl={imageUrl}
          />
          {label && <Label story={story} />}

          {headline && (
            <Headline
              styleName="headline"
              headlineStyles={{ fontSize: isFirstCollection ? "24px" : "20px" }}
              headline={headline}
              sectionSlug={sectionSlug}
            />
          )}

          {showSubheadline && story?.subheadline && (
            <SubHeadline styleName="subheadline" subHeadline={story?.subheadline} sectionSlug={sectionSlug} />
          )}
          <PublishAndReadTime story={story} showReadTime={showReadTime} showTimestamp={showTimestamp} />
        </div>
      </Link>
    </div>
  );
};

HeroStory.propTypes = {
  story: object,
  showThumbnail: bool,
  showReadTime: bool,
  showTimestamp: bool,
  showStorySeparator: bool,
  showSubheadline: bool,
  isFirstCollection: bool,
  defaultFallback: bool,
  sectionSlug: string,
};
